import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Table from "../../components/Table";
import Loader from "../../components/Loader";
import { microsoftMessageColumn } from "../../components/headerContent";
import RowMicrosoftMessage from "./RowMicrosoftMessage";
import { useTranslation } from "react-i18next";

export default function MicrosoftMessage() {
    const { apiUrl } = useContext(AuthContext);
    const [allServices, setAllServices] = useState([]);
    const [messagesByServices, setMessagesByServices] = useState([]);
    const [serviceSelected, setServicesSelected] = useState([]);
    const { t } = useTranslation();

    const getMessageCenter = async () => {
        const res = await axios.get(`${apiUrl}microsoft/messageCenter`, { withCredentials: true });
        return res.data.value.sort((a, b) => new Date(b.lastModifiedDateTime) - new Date(a.lastModifiedDateTime));
    };

    const messageCenter = useQuery({
        queryKey: ["messageCenter"],
        queryFn: getMessageCenter,
    });

    useEffect(() => {
        if (messageCenter.isFetched && Array.isArray(messageCenter.data)) {
            let services = [];

            messageCenter.data.forEach((element) => {
                if (element.services && Array.isArray(element.services)) {
                    element.services.forEach((service) => {
                        services.push(service);
                    });
                }
            });

            setAllServices([...new Set(services)]);
        }
    }, [messageCenter.isFetched, messageCenter.data]);

    const handleServicesFiltered = () => {
        if (Array.isArray(messageCenter.data)) {
            const messagesFiltered = messageCenter.data.filter((message) =>
                serviceSelected.length > 0
                    ? message.services.some((item) => serviceSelected.includes(item))
                    : true
            );
            setMessagesByServices(messagesFiltered);
        } else {
            setMessagesByServices([]);
        }
    };

    useEffect(() => {
        if (!messageCenter.isLoading) {
            handleServicesFiltered();
        } else {
            setMessagesByServices([]);
        }
    }, [serviceSelected, messageCenter.isLoading, messageCenter.data]);

    const handleSelectedServices = (e) => {
        const selectedOptions = Array.from(e.target.selectedOptions).map(
            (option) => option.value
        );
        setServicesSelected(selectedOptions);
    };

    return (
        <>
            {!messageCenter.isLoading ? (
                <>
                    <form className="form form-ecp-microsoft">
                        <div className="form-input_container">
                            <label htmlFor="type">Service</label>
                            <select
                                className="only"
                                id="type"
                                onChange={handleSelectedServices}
                                multiple
                                style={{ height: "10rem", width: "20rem" }}
                            >
                                <option value="">{t("Tous")}</option>
                                {allServices.length > 0 &&
                                    allServices.map((service) => (
                                        <option key={service} value={service}>
                                            {service}
                                        </option>
                                    ))}
                            </select>
                        </div>
                    </form>
                    <div className='cato-content-table'>
                        <Table
                            tableColumns={microsoftMessageColumn}
                            tableData={
                                messagesByServices.length > 0
                                    ? messagesByServices
                                    : messageCenter.data || []
                            }
                            checkbox={false}
                            rowComponent={RowMicrosoftMessage}
                        />
                    </div>
                </>
            ) : (
                <Loader />
            )}
        </>
    );
}
